import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked, Renderer } from 'marked';

@Pipe({
  name: 'markdown',
})
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
    const renderer = new Renderer();
    renderer.link = ({ href, text }) => {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    };

    marked.setOptions({
      gfm: true,
      breaks: true,
    });
    marked.use({ renderer });
  }

  transform(value: string): SafeHtml {
    if (!value) return '';
    const html = marked.parse(value);
    return this.sanitizer.bypassSecurityTrustHtml(html as string);
  }
}
